// extracted by mini-css-extract-plugin
export default {"root":"NZCOstI4","button":"jeB0lOVv","icon":"DrEdAQ4F","label":"JDi8k6QX"};